import { render, staticRenderFns } from "./goTop.vue?vue&type=template&id=179785a8&scoped=true&"
import script from "./goTop.vue?vue&type=script&lang=js&"
export * from "./goTop.vue?vue&type=script&lang=js&"
import style0 from "./goTop.vue?vue&type=style&index=0&id=179785a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179785a8",
  null
  
)

export default component.exports